<template>
   <el-card :class="`box-card user-verification-card mt-3 ${nivel}`">
<!--      <div slot="header">
         <strong>PERFIL {{status}}</strong>
      </div>-->
      <b-row align-content="center" align-h="center" align-v="center">
         <b-col cols="12" class="text-center">
            <el-avatar fit="cover" :size="110" :src="user.avatarUrl || NoAvatar"></el-avatar>
            <div v-if="loading" style="margin: -10px 0 10px 0;">
               <i class="el-icon-loading"></i>
            </div>
            <div v-else class="badge-nivel">
               <img v-if="nivel" :src="nivel === 'ouro' ? BadgeNivelOuro : nivel === 'prata' ? BadgeNivelPrata : nivel === 'bronze' ? BadgeNivelBronze : ''" alt="Brazão">
            </div>
            <h5 class="text-dark">{{user.firstName}} {{user.lastName}}</h5>
            <p v-if="loading" class="nivel text-muted">Carregando nível...</p>
            <p v-else class="nivel">Nível {{nivel}}</p>
            <hr>
         </b-col>

         <b-col cols="9">
            <h6 class="text-dark text-center">Verificações do {{userType}}:</h6>
            <ul class="list-unstyled pl-3">
               <li v-for="(item, index) in verificationItens" :key="index" :class="`${item.checked ? 'checked' : 'no-checked'}`">
                 <span v-if="loading" style="margin-right: 7.5px">
                     <i class="el-icon-loading"></i>
                  </span>
                  <span v-else >
                     <img :src="item.checked ? CheckImg : NoCheckImg" alt="">
                  </span>
                  {{item.name}}
               </li>
            </ul>
         </b-col>

         <div class="px-3 text-center" v-if="showCTA && nivel !== 'ouro' && !loading ">
            <hr>
            <p class="font-strong text-muted">Torne-se um usuário <span style="color: #BD992C">Ouro</span>, e aumente a sua reputação na plataforma Pedale.</p>

            <el-button
               class="font-weight-bold text-uppercase mb-3 mx-auto"
               size="mini"
               type="primary"
               @click="$router.push({name: 'verificacoes'})"
            >
               Verifique seu perfil agora
            </el-button>
         </div>

         <div class="px-3 text-center" v-if="nivel === 'ouro' && !loading">
            <hr>
            <p class="font-strong text-dark text-center">
               <span class="text-capitalize">{{userType}}</span> com reputação <span style="color: #BD992C">Ouro</span> na Pedale. Este
               {{userType}} é confiável!</p>
         </div>

         <div v-if="showBtnBikes && !loading" class="px-3 text-center w-100">
            <hr>
            <el-button
               @click="() => this.$router.push(`/anunciante/${userId}`)"
               type="primary"
               size="mini"
            >
              <strong>Ver bicicletas do anfitrião</strong>
            </el-button>
         </div>

      </b-row>
   </el-card>
</template>

<script>
import CheckImg from "@/assets/img/check.svg"
import NoCheckImg from "@/assets/img/no-check.svg"
import BadgeNivelOuro from "@/assets/img/nivel-ouro.svg"
import BadgeNivelPrata from "@/assets/img/nivel-prata.svg"
import BadgeNivelBronze from "@/assets/img/nivel-bronze.svg"
import NoAvatar from "@/assets/img/no-avatar-2.jpg"
import UserService from '@/services/user.service';
export default {
   name: 'UserVerificationCard',
   props: {
      userId: {
         type: String,
      },
      showBtnBikes: {
         type: Boolean,
         default: false
      },
      showCTA: {
         type: Boolean,
         default: false
      },
      refetch: {
         type: Boolean,
         default: false
      },
      userType: {
         type: String,
         default: 'anfitrião'
      }
   },
   data() {
      return {
         CheckImg,
         NoCheckImg,
         BadgeNivelOuro,
         BadgeNivelPrata,
         BadgeNivelBronze,
         NoAvatar,
         loading: true,
         nivel: '',
         baseUrl: process.env.VUE_APP_BASE_URL,
         apiV1: process.env.VUE_APP_API_V1,
         user: {
            firstName: '',
            lastName: '',
            avatarUrl: ''
         },
         verificationItens: [
            {
               name: 'Foto Perfil',
               checked: false
            },
            {
               name: 'Facebook',
               checked: false,
            },
            {
               name: 'Instagram',
               checked: false
            },
            {
               name: 'Strava',
               checked: false
            },
            {
               name: 'Telefone',
               checked: false
            },
            {
               name: 'Documento pessoal',
               checked: false
            },
            {
               name: 'Endereço',
               checked: false

            }
         ],
         scores: {
            avatar: null,
            social: null,
            phone: null,
            personalDoc: null,
            addressDoc: null
         }
      }
   },
   beforeDestroy() {
      this.userData = {}
      this.nivel = ''
      this.user = {}
      this.scores = {}
   },
   async mounted() {
      if (this.userId) {
         await this.getUserVerifications()
      }
   },
   methods: {
      async getUserVerifications() {
         try {
            const { data } = await UserService.getUserVerifications(this.userId)
            this.nivel = data.nivel
            this.scores = data.scores
            this.verificationItens = data.verifications
            this.user.avatarUrl = this.createUrlAvatar(data.userData.avatar)
            this.user.firstName = data.userData.firstName
            this.user.lastName = data.userData.lastName

         } finally {
            this.loading = false
         }
      },
      createUrlAvatar(url) {
         if (url) {
            let uri;
            const imgDir = url.destination;
            if (url.filename) {
               uri = `${this.baseUrl}/${imgDir}/${url.filename}`
               return uri;
            }
         }
      }
   },
   watch: {
      refetch: async function (v) {
         if (v) {
            this.loading = true
            await this.getUserVerifications();
         }
      }
   }
}
</script>

<style lang="scss" scoped>

</style>
